module.exports = __webpack_public_path__ + "static/media/share-alt-square.38aa2a17.svg";